import { Link } from "react-router-dom";
import { ArrowUp } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

export const Footer = () => (
  <footer data-testid="footer-section" className="relative border-t border-zinc-800/60 overflow-hidden">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-10">
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-12">
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-teal-400">
            BTM Tech Developments
          </p>
          <p className="mt-4 font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-zinc-50 leading-tight">
            We bring ideas
            <br />
            <span className="text-teal-400">to life.</span>
          </p>
          <p className="mt-5 font-mono text-xs uppercase tracking-[0.2em] text-zinc-500">
            Calgary · Alberta · Canada
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-10 sm:gap-16">
          <div className="flex flex-col gap-3">
            <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-600">Explore</p>
            <button data-testid="footer-link-services" onClick={() => scrollToId("services")} className="text-left text-sm text-zinc-400 hover:text-teal-300 transition-colors">Services</button>
            <button data-testid="footer-link-process" onClick={() => scrollToId("process")} className="text-left text-sm text-zinc-400 hover:text-teal-300 transition-colors">Process</button>
            <button data-testid="footer-link-contact" onClick={() => scrollToId("contact")} className="text-left text-sm text-zinc-400 hover:text-teal-300 transition-colors">Contact</button>
          </div>
          <div className="flex flex-col gap-3">
            <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-600">Legal</p>
            <Link to="/privacy" data-testid="footer-link-privacy" className="text-sm text-zinc-400 hover:text-teal-300 transition-colors">
              Privacy Policy
            </Link>
            <a href="mailto:sales@btmtechdevelopments.com" data-testid="footer-email-link" className="text-sm text-zinc-400 hover:text-teal-300 transition-colors">
              sales@btmtechdevelopments.com
            </a>
          </div>
        </div>
      </div>

      <div className="mt-16 select-none pointer-events-none" aria-hidden="true">
        <p className="font-display font-extrabold text-[18vw] leading-[0.8] text-center text-zinc-800/40 tracking-tight">
          BTM
        </p>
      </div>

      <div className="mt-6 pt-8 border-t border-zinc-800/60 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-zinc-600">
          © {new Date().getFullYear()} BTM Tech Developments. All rights reserved.
        </p>
        <button
          data-testid="back-to-top-button"
          onClick={() => (window.__lenis ? window.__lenis.scrollTo(0) : window.scrollTo({ top: 0, behavior: "smooth" }))}
          className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-[0.18em] text-zinc-500 hover:text-teal-300 transition-colors"
        >
          Back to top <ArrowUp size={14} />
        </button>
      </div>
    </div>
  </footer>
);
